<script>
	import { createEventDispatcher, tick } from "svelte";
	import {
		Dropdown,
		DropdownMenu,
		DropdownToggle,
		DropdownItem,
	} from "@sveltestrap/sveltestrap";

	export let row = {};
	export let key = "";
	export let options = "";

	const dispatch = createEventDispatcher();
	let isOpen = false;
	let menuEl;

	$: status = row[key];
	$: allowedTransitions = row.allowedTransitions || [];

	let damageStatuses = {
		NoNewDamage: `<p class="status-bar status-bar-7">No New Damage</p>`,
		NoDamage: `<p class="status-bar status-bar-9">No Damage</p>`,
	};

	let workOrderStatuses = {
		Triage: `<p class="status-bar status-bar-pending work-order-status">Triage</p>`,
		InProgress: `<p class="status-bar status-bar-pending work-order-status">In Progress</p>`,
		Completed: `<p class="status-bar status-bar-6 work-order-status">Completed</p>`,
		Cancelled: `<p class="status-bar status-bar-black work-order-status">Cancelled</p>`,
		InWorkshop: `<p class="status-bar status-bar-9 work-order-status">In Workshop</p>`,
		CompletedByWorkshop: `<p class="status-bar status-bar-8 work-order-status">Completed by Workshop</p>`,
		ReadyForCollection: `<p class="status-bar status-bar-6 work-order-status">Ready for Collection</p>`,
		PendingCompletion: `<p class="status-bar status-bar-pending work-order-status">Pending Completion</p>`,
	};

	let statusComponents = {
		damages: damageStatuses,
		workOrder: workOrderStatuses,
	};

	const toggle = () => (isOpen = !isOpen);

	$: if (isOpen) {
		tick().then(
			() => menuEl && dispatch("menuRect", menuEl.getBoundingClientRect())
		);
	} else {
		dispatch("menuRect", null);
	}

	function selectStatus(newStatus) {
		// DropdownItem's own toggle/autoClose behavior already closes the
		// menu on click (see sveltestrap's DropdownItem.handleItemClick) —
		// toggling isOpen here too would double-toggle it back open.
		dispatch("statusChange", { row, newStatus });
	}
</script>

{#if options === "workOrder" && allowedTransitions.length > 0}
	<!-- Interacting with the status dropdown shouldn't also trigger the
	     table row's own click-to-navigate behavior. -->
	<div
		on:click|stopPropagation
		on:keydown|stopPropagation
		role="presentation"
	>
		<Dropdown {isOpen} {toggle}>
			<DropdownToggle
				tag="button"
				class="d-flex align-items-center"
				style="cursor:pointer; gap: 4px; width: fit-content; background: none; border: none; padding: 0;"
			>
				{@html statusComponents[options][status]}
				<img
					src="/assets/icon-chevron-down.png"
					alt="chevron-down"
					style="width: 18px; height: 18px; margin-left: 10px;"
				/>
			</DropdownToggle>
			<DropdownMenu>
				<div bind:this={menuEl}>
					{#each allowedTransitions as transition}
						<DropdownItem on:click={() => selectStatus(transition)}>
							{@html statusComponents[options][transition]}
						</DropdownItem>
					{/each}
				</div>
			</DropdownMenu>
		</Dropdown>
	</div>
{:else}
	{@html statusComponents[options][status]}
{/if}

<style>
	:global(.status-bar) {
		margin: 0;
	}

	:global(.status-bar.work-order-status) {
		padding: 4px 8px;
		border-radius: 4px;
		font-size: 12px;
	}
</style>
